import { courseUiText } from "../copy.js";
import Picture from "./picture.marko";
import Icon from "./icon.marko";

<const/uiLang=$global.uiLang || input.copy?.uiLang || 'en'/>

<div class=["ll-cx__v", input.v.image && "ll-cx__v--comic", input.v.panels && "ll-cx__v--panels"] data-g=(input.v.g || false) data-ll-cx-item>
  <if=(input.v.image && !input.v.panels)>
    <Picture class="ll-cx__comic" image=input.v.image alt=(input.v.titleEn || "")/>
  </if>
  <div class="ll-cx__lines" style=(input.v.panels ? `--ll-panels: ${input.v.lines.length}` : false)>
    <for|line, n| of=input.v.lines>
      <div class=["ll-cx__line", line.who && "ll-cx__line--said", line.image && "ll-cx__line--panel"] data-ll-gap-line data-audio=(line.audio || false)>
        <const/panel=input.v.panels && line.image/>
        <if=panel>
          <button type="button" class="ll-cx__thumb" data-ll-comic-panel aria-label=`${input.copy.play || courseUiText("Play", uiLang)} ${n + 1}` aria-pressed="false" disabled><b aria-hidden="true">${n + 1}</b><Picture image=line.image sizes="7rem" alt=""/></button>
        </if>
        <${panel ? "div" : null} class="ll-cx__panel-card">
        <if=panel>
          <Picture class="ll-cx__panel" image=line.image sizes="(max-width: 620px) 34vw, 10.5rem" alt=""/>
        </if>
        <${panel ? "div" : null} class="ll-cx__panel-text">
        <if=line.who>
          <span class="ll-cx__who"><b>${n + 1}</b> ${line.who}</span>
        </if>
        <p class=["ll-cx__say", line.paragraph && "ll-cx__say--paragraph"] lang=input.lang dir=(["ar", "fa"].includes(input.lang) ? "rtl" : "ltr")>
          <for|part| of=line.parts>
            <if=part.gap>
              <span class=["ll-cx__gap-slot", (input.v.image || input.v.panels) && "ll-cx__answer-slot"]>
                <if=(input.v.image || input.v.panels)>
                  <for|answer| of=[...input.v.bank, ...part.answers]><span class="ll-cx__answer-size" aria-hidden="true">${answer}</span></for>
                </if>
                <button type="button" class="ll-cx__gap" data-ll-gap data-answers=JSON.stringify(part.answers) data-keys=JSON.stringify(part.keys || []) aria-label=courseUiText("gap", uiLang)>&nbsp;</button>
                <input class="ll-cx__type-field" lang=input.lang dir=(["ar", "fa"].includes(input.lang) ? "rtl" : "ltr") data-ll-type-field type="text" size=8 autocomplete="off" autocapitalize="off" spellcheck="false" enterkeyhint="done" aria-label=input.copy.typeAnswer/>
              </span>
            </if>
            <else>${part.t}</else>
          </for>
        </p>
        <p class="ll-cx__en">${line.en}</p>
        </>
        </>
      </div>
    </for>
  </div>
  <div class="ll-cx__bank">
    <for|word| of=input.v.bank>
      <button type="button" class="ll-cx__chip" data-ll-chip lang=input.lang dir=(["ar", "fa"].includes(input.lang) ? "rtl" : "ltr")>${word}</button>
    </for>
  </div>
  <div class="ll-cx__type">
    <div class="ll-cx__keys-row">
      <div class="ll-cx__keys" data-ll-keys></div>
      <button type="button" class="ll-cx__key" data-ll-type-backspace aria-label=input.copy.typeBackspace><Icon name="delete-letter" size=18 weight=2/></button>
    </div>
    <button type="button" class="ll-course-primary ll-cx__type-check" data-ll-type-check>${input.copy.typeCheck}</button>
  </div>
</div>
